/**
 * Deterministic PRNG (mulberry32). The simulation must never call `Math.random()`
 * directly: an authoritative server and its clients have to be able to replay the
 * exact same match from the same seed, and so do regression tests.
 */
export type RandomState = { seed: number };

export function createRandom(seed = 1): RandomState {
  // Any non-zero 32-bit state works; 1 is a safe substitute for a zero seed.
  return { seed: (Math.floor(seed) >>> 0) || 1 };
}

export function nextRandom(state: RandomState): number {
  state.seed = (state.seed + 0x6d2b79f5) >>> 0;
  let value = state.seed;
  value = Math.imul(value ^ (value >>> 15), value | 1);
  value ^= value + Math.imul(value ^ (value >>> 7), value | 61);
  return ((value ^ (value >>> 14)) >>> 0) / 4294967296;
}

export function randomBetween(state: RandomState, min: number, max: number) {
  return min + nextRandom(state) * (max - min);
}

export function randomInt(state: RandomState, maxExclusive: number) {
  return Math.floor(nextRandom(state) * maxExclusive);
}
